import { jsx as _jsx } from "react/jsx-runtime";
import { ListItemIcon } from "@mui/material";
import { forwardRef } from "react";
export const UiListItemIcon = forwardRef((props, ref) => _jsx(ListItemIcon, Object.assign({ ref: ref }, props)));
//# sourceMappingURL=ui_list_item_icon.js.map